var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import Link from "@irati/ui/src/Link";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { Para } from "@irati/ui/src/Labels";
import authentication from "@irati/auth";
import EmojiWithText from "@irati/ui/src/EmojiWithText";
import { PaddingGrid, WhiteBackground } from "../../../components/shared";
import { InformationText, WhiteH2, WhiteH4, MobileSubHeader, MobileCallbackWrapper, SpaceBetween, BannerHeadings, StyledRow, MobileBanner, StyledBanner, TermsWrapper, TermsText } from "./styles";
import Callback from "../../../components/Upsell/Callback";
var upsellBanner = "https://res.cloudinary.com/perkbox/image/upload/v1556812328/deals-light-ui/web/medical/medicalUpsell.jpg";
var bannerProps = {
    backgroundPosition: "0 34%",
    bannerImg: upsellBanner,
    minHeight: "500",
    tabletMinHeight: "200",
    cutOffBottom: false
};
var MedicalUpsell = /** @class */ (function (_super) {
    __extends(MedicalUpsell, _super);
    function MedicalUpsell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MedicalUpsell.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        var publicName = authentication.userTenant().public_name;
        var privacyLink = (React.createElement(Link, { href: formatMessage({
                id: "medical.upsellPage.smallPrint.privacyHref"
            }), rel: "noopener noreferrer", target: "_blank" },
            React.createElement(FormattedMessage, { id: "medical.upsellPage.smallPrint.privacyText" })));
        var termsLink = (React.createElement(Link, { href: formatMessage({
                id: "medical.upsellPage.smallPrint.termsHref"
            }), rel: "noopener noreferrer", target: "_blank" },
            React.createElement(FormattedMessage, { id: "medical.upsellPage.smallPrint.termsText" })));
        return (React.createElement(WhiteBackground, null,
            React.createElement(Row, null,
                React.createElement(Col, { xsHidden: true, lg: 12 },
                    React.createElement(StyledBanner, __assign({}, bannerProps),
                        React.createElement(PaddingGrid, null,
                            React.createElement(SpaceBetween, null,
                                React.createElement(BannerHeadings, null,
                                    React.createElement(WhiteH2, { base: true },
                                        React.createElement(FormattedMessage, { id: "medical.upsellPage.header", values: { publicName: publicName } })),
                                    React.createElement(WhiteH4, { large: true },
                                        React.createElement(FormattedMessage, { id: "medical.upsellPage.subHeader" }))),
                                React.createElement(Callback, null))))),
                React.createElement(Col, { xs: 12, smHidden: true, mdHidden: true, lgHidden: true },
                    React.createElement(MobileBanner, __assign({}, bannerProps),
                        React.createElement(PaddingGrid, null,
                            React.createElement(WhiteH2, { base: true },
                                React.createElement(FormattedMessage, { id: "medical.upsellPage.header", values: { publicName: publicName } })))),
                    React.createElement(MobileSubHeader, null,
                        React.createElement(FormattedMessage, { id: "medical.upsellPage.subHeader" })),
                    React.createElement(MobileCallbackWrapper, null,
                        React.createElement(Callback, null)))),
            React.createElement(PaddingGrid, null,
                React.createElement(StyledRow, null,
                    React.createElement(Col, { xs: 12, md: 8 },
                        React.createElement(InformationText, null,
                            React.createElement(Para, { large: true, light: true },
                                React.createElement(FormattedMessage, { id: "medical.upsellPage.text.para1" })),
                            React.createElement(Para, { large: true, light: true },
                                React.createElement(FormattedMessage, { id: "medical.upsellPage.text.para2" })),
                            React.createElement(Para, { large: true, light: true },
                                React.createElement(FormattedMessage, { id: "medical.upsellPage.text.para3" }))),
                        React.createElement(Para, null,
                            React.createElement(FormattedMessage, { id: "medical.upsellPage.features.header", values: { publicName: publicName } })),
                        React.createElement(EmojiWithText, { emoji: "female-doctor", text: formatMessage({
                                id: "medical.upsellPage.features.feature1"
                            }) }),
                        React.createElement(EmojiWithText, { emoji: "calling", text: formatMessage({
                                id: "medical.upsellPage.features.feature2"
                            }) }),
                        React.createElement(EmojiWithText, { emoji: "fast_forward", text: formatMessage({
                                id: "medical.upsellPage.features.feature3"
                            }) }),
                        React.createElement(EmojiWithText, { emoji: "spiral_calendar_pad", text: formatMessage({
                                id: "medical.upsellPage.features.feature4"
                            }) }),
                        React.createElement(EmojiWithText, { emoji: "hourglass_flowing_sand", text: formatMessage({
                                id: "medical.upsellPage.features.feature5"
                            }) }),
                        React.createElement(EmojiWithText, { emoji: "file_folder", text: formatMessage({
                                id: "medical.upsellPage.features.feature6"
                            }) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 8 },
                        React.createElement(TermsWrapper, null,
                            React.createElement(TermsText, null,
                                React.createElement(FormattedMessage, { id: "medical.upsellPage.smallPrint.line1" })),
                            React.createElement("strong", null,
                                React.createElement(TermsText, null,
                                    React.createElement(FormattedMessage, { id: "medical.upsellPage.smallPrint.line2" }))),
                            React.createElement(TermsText, null,
                                React.createElement(FormattedMessage, { id: "medical.upsellPage.smallPrint.privacy", values: { link: privacyLink } }),
                                React.createElement("br", null),
                                React.createElement(FormattedMessage, { id: "medical.upsellPage.smallPrint.terms", values: { link: termsLink } })),
                            React.createElement(TermsText, null,
                                React.createElement(FormattedMessage, { id: "medical.upsellPage.smallPrint.copyright" }))))))));
    };
    return MedicalUpsell;
}(Component));
export default injectIntl(MedicalUpsell);
